import { Route } from '@angular/router';

import { isUserSignedIn, isUserSignedOut } from './auth/auth.function';
import { MainRoutingUtility } from './routing/main-routing.utility';
import { RouteFragment } from './shared/common';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: RouteFragment.Main,
    pathMatch: 'full',
  },
  {
    path: RouteFragment.SignIn,
    canActivate: [isUserSignedOut],
    loadComponent: () => import('./auth/sign-in/sign-in.component').then((c) => c.SignInComponent),
  },
  {
    path: '',
    canActivate: [isUserSignedIn],
    resolve: { main: MainRoutingUtility.mainResolver },
    loadComponent: () => import('./main/main.component').then((c) => c.MainComponent),
    children: [
      {
        path: RouteFragment.Main,
        loadChildren: () => import('./main/main.routes').then((r) => r.mainRoutes),
      },
      {
        path: RouteFragment.NoRole,
        title: 'No role',
        loadComponent: () =>
          import('./pages/no-role/no-role.component').then((c) => c.NoRoleComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: RouteFragment.Main,
  },
];
